<template>
  <div v-if="type!== 'receipt' || (type==='receipt' && application.length>0)">
    <v-card-title primary-title>
      <v-layout row justify-space-between dense>
        <v-flex>{{ item.name }}</v-flex>
        <v-subheader>
          {{ this.prefecture }}
        </v-subheader>
        <v-subheader>{{ this.city }}</v-subheader>
      </v-layout>
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text>
      <v-layout row wrap>
        <v-flex xs3 v-if="item.photo.length > 0 && item.photo[0].image_default.substring(0,5) === 'https'">
          <v-img
            :src="`${item.photo[0].image_default}`"
            height="125px"
            width="125px"
            position="center left"
          >
          </v-img>
        </v-flex>
        <v-flex xs3 v-else-if="item.photo.length > 0 && item.photo[0].image_default.substring(0,5) !== 'https'">
          <v-img
            :src="`${item.photo[0].image_default}`"
            height="125px"
            width="125px"
            position="center left"
          >
          </v-img>
        </v-flex>
        <v-flex xs3 v-else>
          <v-img
            src="data:image/png;base64,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"
            height="125px"
            width="125px"
            position="center left"
          >
          </v-img>
        </v-flex>
        <v-flex xs6>
          <v-list dense expand style="float: left;">
            <v-list-tile
              v-for="detail in Object.entries(getDetails(item, application))"
              :key="detail[0]"
            >
              <v-list-tile-content>
                <v-list-tile-sub-title justify-end>


        <span class="text--primary">{{ $t(`card_location.${detail[0]}`) }}</span>
        ：
        <span v-if="detail[0]!=='status'">{{ detail[1] }}</span>
        <span v-else-if="detail[1] ==0">{{$t('shared.status.pending')}}</span>
        <span v-else-if="detail[1] ==1">{{$t('shared.status.rejected')}}</span>
        <span v-else-if="detail[1] ==2">{{$t('shared.status.approved')}}</span>
                </v-list-tile-sub-title>
              </v-list-tile-content>

           　　
              <v-btn style="float: right;" outline color="primary" v-if="detail[1]==1 && detail[0]=='status'" @click.prevent="dialog = true">{{$t('dialog.rejection_reason')}}</v-btn>
              <v-dialog v-model="dialog" persistent max-width="700" v-if="examination!==undefined">
                <v-card>
                  <v-card-title>
                    <v-icon>delete</v-icon>
                    <span><strong>{{$t('dialog.rejection_reason')}}</strong></span>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row>
                      <v-flex>
                        <label>却下理由</label>
                        <v-flex xs9>
                          <v-checkbox disabled  v-model="examination[0].rejection_reason_1"  label="公序良俗に反する為"></v-checkbox>
                          <v-checkbox disabled v-model="examination[0].rejection_reason_2" label="政治活動もしくは選挙運動、またはこれらに関連する行為に利用する為"></v-checkbox>
                          <v-checkbox disabled v-model="examination[0].rejection_reason_3" label="宗教活動、またはこれに関連する行為に利用する為"></v-checkbox>
                        </v-flex>



                        <v-textarea
                          disabled
                          :label="$t('apply.other')"
                          v-model="examination[0].rejection_reason"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click.stop="dialog = false">{{ $t('common.close') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-list-tile>
          </v-list >
        </v-flex>
        <v-flex xs3 v-if="type === 'receipt'">
          <v-list dense expand>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-sub-title justify-end>
                  <span class="text--primary">ロイヤリティ：</span>：<span>{{ item.royalty * 100 }}％</span>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-sub-title justify-end>
                  <span class="text--primary">単価：</span>：<span>{{ item.usage_fee | toCurrency }}</span>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile style="margin-left: 20px;">
              <v-list-tile-content>
                <v-list-tile-sub-title justify-end>
                  <span class="text--primary">{{item.company.name}}：</span>：<span>{{ item.usage_fee * (1-item.royalty) | toCurrency}}</span>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile style="margin-left: 20px;">
              <v-list-tile-content>
                <v-list-tile-sub-title justify-end>
                  <span class="text--primary">ビークルー：</span>：<span>{{(item.usage_fee * item.royalty)  | toCurrency }}</span>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions v-if="type==='receipt'">
      <v-spacer></v-spacer>
      小計：{{item.usage_fee*item.royalty*(application?application.length:0) | toCurrency}}
    </v-card-actions>
  </div>
</template>
<script>
    import {getType} from "../../utils/facilities";
    import {CITY_SELECT_VALUE, LOCATION_APPLICATION_STATUS, PREFECTURE_SELECT_VALUE} from "../../utils/masterdata";

    export default {
        props: ["item", "application", "type", "removeLocation", "index", "mode","examination"],
        mounted() {
            this.prefecture = PREFECTURE_SELECT_VALUE(this.item.prefecture).text;
            this.city = CITY_SELECT_VALUE(this.item.prefecture, this.item.city).text;
        },
        data() {
            return {
                prefecture: '',
                city: '',
                showAgreeTerms: false,
                removeDialog: false,
              dialog: false,
              statuses: LOCATION_APPLICATION_STATUS,
            }
        },
        methods: {
            getDetails(item, application) {
                var usage_ends_at = '';

                if ('application_location' in item) {
                    usage_ends_at = item.application_location.usage_ends_at;
                } else if (application && 'application_location' in application) {
                    usage_ends_at = application.application_location.usage_ends_at;
                }
                if (!usage_ends_at && application && 'usage_ends_at' in application) {
                    usage_ends_at = application.usage_ends_at;
                }
                if (this.type === "receipt") {
                    return {
                        type: getType(item),
                        beacon_count: item.beacon_count,
                        user_count: (this.application ? this.application.length : 0),
                        company_name: item.company.name,
                    };
                } else if (this.type === "search") {
                        return {
                            type: getType(item),
                            company_name: item.company.name,
                            beacon_count: item.beacon_count,
                            fee: `${item.usage_fee}円/月`,
                        };
                } else {
                    return {
                        type: getType(item),
                        company_name: item.company.name,
                        beacon_count: item.beacon_count,
                        fee: `${item.usage_fee}円/月`,
                        status: item.application_location.status
                    };
                }
            }
        }
    };
</script>
